<div class="upcoming-sessions-container">
    <!-- Header Section -->
    <header class="page-header">
        <div class="title-row">
            <div class="text-group">
                <h1>Scheduled Sessions</h1>
                <p>Your accepted & confirmed mentoring sessions.</p>
            </div>
            <span class="session-count-badge" *ngIf="!isLoading">{{ sessions.length }} sessions</span>
            <span class="session-count-badge skeleton-shimmer skeleton-mini-count" *ngIf="isLoading"></span>
        </div>
    </header>

    <!-- Sessions Grid -->
    <div class="sessions-grid" *ngIf="isLoading">
        <div class="session-card skeleton-session-card" *ngFor="let i of [1,2,3,4,5,6]">
            <div class="card-header">
                <div class="skeleton-shimmer skeleton-badge"></div>
                <div class="skeleton-shimmer skeleton-badge"></div>
            </div>
            <div class="user-info">
                <div class="avatar skeleton-shimmer"></div>
                <div class="name-box">
                    <div class="skeleton-shimmer skeleton-name"></div>
                    <div class="skeleton-shimmer skeleton-subtle"></div>
                </div>
            </div>
            <div class="session-content">
                <div class="skeleton-shimmer skeleton-topic"></div>
                <div class="details">
                    <div class="skeleton-shimmer skeleton-detail"></div>
                    <div class="skeleton-shimmer skeleton-detail"></div>
                </div>
            </div>
            <div class="card-actions">
                <div class="skeleton-shimmer skeleton-btn-large"></div>
                <div class="skeleton-shimmer skeleton-btn-small"></div>
            </div>
        </div>
    </div>

    <!-- Sessions Grid -->
    <div class="sessions-grid" *ngIf="!isLoading">
        <div class="session-card" *ngFor="let session of sessions" [class.highlight-card]="session.isToday">
            <div class="card-header">
                <span class="badge today-badge" *ngIf="session.isToday">
                    <span class="dot"></span> TODAY
                </span>
                <span class="type-badge">{{ session.type }}</span>
            </div>

            <div class="user-info">
                <div class="avatar" [ngClass]="session.avatarColorClass">
                    {{ session.initials }}
                </div>
                <div class="name-box">
                    <h3>{{ session.studentName }}</h3>
                    <span class="session-type">{{ session.sessionType }}</span>
                </div>
            </div>

            <div class="session-content">
                <p class="topic">{{ session.topic }}</p>
                <div class="details">
                    <span><i class="bi bi-calendar3"></i> {{ session.date }}</span>
                    <span><i class="bi bi-clock"></i> {{ session.time }}</span>
                    <span><i class="bi bi-hourglass-split"></i> {{ session.duration }}</span>
                </div>
            </div>

            <div class="card-actions">
                <button class="btn btn-join" (click)="joinMeeting(session)">
                    <i class="bi bi-camera-video"></i> Join Meeting
                </button>
                <button class="btn btn-complete" (click)="markComplete(session)">
                    <i class="bi bi-check-circle"></i> Complete
                </button>
            </div>
        </div>
    </div>
</div>